import { combineReducers } from 'redux';

export const defaultZoomTo = {
    minX: 0,
    minY: 0,
    maxX: 0,
    maxY: 0
};
export const defaultMarquee = {
    minX: 0,
    minY: 0,
    maxX: 0,
    maxY: 0
};

let modifiers = {
    shift: false,
    ctrl: false,
    space: false
};

let default_multiselect = false;
let default_select = true;
let default_pan = false;

const zoomToReducer = function(
    state = defaultZoomTo, action)
{
    switch (action.type) {
        case 'SET_ZOOM_TO_BOUNDS': {
            return action.zoomTo || defaultZoomTo;
        }
        default: {
            return state;
        }
    }
}

const marqueeReducer = function(
    state = defaultMarquee, action)
{
    switch (action.type) {
        case 'SET_MARQUEE': {
            return action.marquee || defaultMarquee;
        }
        default: {
            return state;
        }
    }
}

const notecardPreviewReducer = function(
    state = defaultMarquee, action
) {
    switch (action.type) {
        case 'SET_NOTECARD_PREVIEW': {
            return action.bounds || defaultMarquee;
        }
        default: {
            return state;
        }
    }
}

const multiselectReducer = function (state = false, action) {
    switch (action.type) {

        case 'SET_MULTISELECT_DEFAULT': {
            default_multiselect = action.multiselect;
            return default_multiselect ^ modifiers.shift; //xor
        }

        case 'SET_TOOL_MODIFIER': {
            if (action.mod.shift !== undefined) {
                modifiers.shift = !!action.mod.shift;
            }

            let x = default_multiselect ^ modifiers.shift; //xor

            return x;
        }

        default: {
            return state;
        }
    }
};

const aspectLockReducer = function (state = true, action) {
    switch (action.type) {

        case 'SET_ASPECT_LOCK': {
            let x = action.mod; 
            return x;
        }

        default: {
            return state;
        }
    }
};



const currentToolReducer = function (state = 'SELECT', action) {

    switch (action.type) {
        case 'SET_CURRENT_TOOL': {
            if (action.tool == 'SELECT') {
                default_select = true;
                default_pan = false;
            } else if (action.tool == 'PAN') {
                default_select = false;
                default_pan = true;
            } else if (action.tool == 'NOTECARD') {
                default_select = false;
                default_pan = false;
            } else if (action.tool == 'ZOOM') {
                default_select = false;
                default_pan = false;
            }

            console.log(action.tool);

            return action.tool || state;
        }

        case 'SET_TOOL_MODIFIER': {
            let x = state;
            
            if (action.mod.space !== undefined) {
                modifiers.space = !!action.mod.space;
            }
            
            let isPan = (modifiers.space ^ default_pan); //XOR
            let isSelect = (modifiers.space ^ default_select) //XOR;

            // console.log('isPan', isPan, 'isSelect', isSelect);
            
            if (isPan) {
                x = 'PAN'
            } else if (isSelect) {
                x = 'SELECT'
            }
            
            return x;
        }

        default: {
            return state;
        }
    }
}


const rootReducer = combineReducers({
    zoomTo: zoomToReducer,
    marquee: marqueeReducer,
    notecardPreview: notecardPreviewReducer,
    multiselect: multiselectReducer,
    current: currentToolReducer,
    aspectLock: aspectLockReducer
});

export default rootReducer;